import { graphql } from "../generated";

export const FeaturesFlags = graphql(`
  query FeaturesFlags($names: [String!]) {
    getFeatureFlags(names: $names) {
      name
      isEnabled
    }
  }
`);
